import React from 'react';
import PrimarySection from '../../components/primary-section/PrimarySection';
import PrimarySectionRow from '../../components/primary-section/PrimarySectionRow';
import './ApisDataFeedsLanding.scss';
import Helmet from 'react-helmet';
import { PrimarySectionIndent } from '../../components/primary-section/PrimarySectionIndent';
import { useClassName } from '../../hooks/useClassName';
import { ApisDataFeedsLandingBlock } from './ApisDataFeedsBem';
import { QuestionTypeOption } from '../../enums/QuestionTypeOption';

const NewsLanding: React.FC = () => {
  const cn = useClassName(ApisDataFeedsLandingBlock.Root);

  return (
    <div className={cn()}>
      <Helmet>
        <title>APIs and Data Feeds</title>
      </Helmet>

      <PrimarySection header="APIs and Data Feeds" indent={PrimarySectionIndent.Internal}>
        <p>
          We provide data feeds and APIs that empower our clients to integrate our detailed IPO insights and data
          directly into their daily operations. For more information, please{' '}
          <a href={`/contact-us?questionType=${encodeURIComponent(QuestionTypeOption.ApisAndDataFeed)}`}>
            reach out to us
          </a>
          .
        </p>

        <p>
          These tools are provided exclusively to current IPO Intelligence clients and could involve additional costs.
        </p>

        <p>Our critical IPO data includes:</p>
        <ul>
          <li>Basic offering data</li>
          <li>Historical and forecasted financials</li>
          <li>Lock-up expiration dates</li>
          <li>Pre-IPO private company updates</li>
          <li>SPAC offering and merger data</li>
          <li>Research reports and ratings</li>
          <li>Customizable data sets</li>
        </ul>

        <a
          href={`/contact-us?questionType=${encodeURIComponent(QuestionTypeOption.ApisAndDataFeed)}`}
          className="request-quote-btn"
        >
          REQUEST A QUOTE
        </a>
      </PrimarySection>
    </div>
  );
};

export default NewsLanding;
